import api from './api';

class GameService {
  async startGame() {
    return await api
      .get('/game/start')
      .then(async (response) => {
        return response.data;
      });
  }

  async checkGame(game_uuid) {
    return await api
      .get(`/game/play/${game_uuid}`)
      .then(async (response) => {
        return response.data;
      });
  }

  async playCard(game_uuid, card_uuid, position) {
    try {
      return await api
        .post('/game/play', { game_uuid, card_uuid, position })
        .then(async (response) => {
          return response.status;
        });
    } catch (e) { return false }
  }

  async settings() {
    return await api
      .get(`/game/settings`)
      .then(async (response) => {
        return response.data;
      });
  }

  async getTips(deactivated = false) {
    return await api
      .get(`/game/tips?deactivated=${deactivated}`)
      .then(async (response) => {
        return response.data.tips;
      });
  }

  async deactivateTip(tutorial_uuid) {
    return await api
      .post(`/game/tips/deactivate`, {tutorial_uuid})
      .then(async (response) => {
        return response.data;
      });
  }

  async activateTip(tutorial_uuid) {
    return await api
      .post(`/game/tips/reactivate`, {tutorial_uuid})
      .then(async (response) => {
        return response.data;
      });
  }

  async createTip(title, description, picture, video, view_weight = null) {
    const body = { title, description, picture, video }
    if (view_weight !== null && view_weight !== undefined && view_weight !== '') body.view_weight = Number(view_weight)
    return await api
      .post(`/game/tips`, body)
      .then(async (response) => {
        return response.data;
      });
  }

  async updateTip(tutorial_uuid, updateData) {
    return await api
      .post(`/game/tips/${tutorial_uuid}`, updateData)
      .then(async (response) => {
        return response.data;
      });
  }

  async getNews(deactivated = false) {
    return await api
      .get(`/game/news?deactivated=${deactivated}`)
      .then(async (response) => {
        return response.data.news;
      });
  }

  async createNews(newsData) {
    return await api
      .post('/game/news', newsData)
      .then(async (response) => {
        return response.data;
      });
  }

  async updateNews(news_uuid, newsData) {
    return await api
      .post(`/game/news/${news_uuid}`, newsData)
      .then(async (response) => {
        return response.data;
      });
  }

  async deactivateNews(news_uuid) {
    return await api
      .post('/game/news/deactivate', { news_uuid })
      .then(async (response) => {
        return response.data;
      });
  }

  async activateNews(news_uuid) {
    return await api
      .post('/game/news/reactivate', { news_uuid })
      .then(async (response) => {
        return response.data;
      });
  }
}
// eslint-disable-next-line
export default new GameService();